export default {"src":"/_next/static/media/draftGreyFilled.9c935c8d.svg","height":24,"width":24};